export const filtersInitialState = {
  obraValidacao: null,
  funcionarioValidacao: null,
};
